export const DASHBOARD_APP_IDS = [
  'appointments',
  'asset',
  'attendance',
  'configuration',
  'contracts',
  'crm',
  'document',
  'expenses',
  'field-service',
  'finance',
  'help-desk',
  'home',
  'hr',
  'integrations',
  'inventory',
  'invoicing',
  'maintanance',
  'manufacturing',
  'payroll',
  'point-of-sale',
  'procurement',
  'project',
  'recruitment',
  'rental',
  'sales',
  'schedule-planning',
  'subscriptions',
  'time-off',
  'timesheets',
] as const;

export type DashboardAppId = typeof DASHBOARD_APP_IDS[number];

export const DASHBOARD_IDS: Readonly<Record<DashboardAppId, string>> = Object.fromEntries(
  DASHBOARD_APP_IDS.map((appId) => [appId, `${appId}.main`]),
) as Record<DashboardAppId, string>;
